import React, { useContext } from "react";
import "./NewCollections.css";
import { ShopContext } from "../../Context/ShopContext";
import Item from "../Items/Item";
import default_img from "../../Components/Assets/default_img.png";
import PageLoader from "../Assets/PageLoader/PageLoader";


const mainURL = process.env.REACT_APP_API_BASE_URL;

const NewCollections = () => {
  const { newCollection, loading } = useContext(ShopContext);

  if (loading) {
    return <PageLoader text="Loading new collections" />;
  }

  return (
    <div className="new-collections">
      <h1>NEW COLLECTIONS</h1>
      <hr />

      {newCollection.length === 0 ? (
        <p className="no-product">No Product Found</p>
      ) : (
        <div className="collections">
          {newCollection.map((item) => {
            const imagePath =
              item?.product_images?.[0]?.image_path
                ? `${mainURL}/${item.product_images[0].image_path}`
                : default_img;

            const sellingPrice =
              item?.product_cost?.[0]?.selling_price ?? 0;

            return (
              <Item
                key={item.item_id}
                id={item.item_id}
                name={item.item_name}
                image={imagePath}
                is_wishlist={item.is_wishlist}
                new_price={sellingPrice}
                old_price={sellingPrice}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default NewCollections;
